import React from 'react';
import { Download } from 'lucide-react';
import { exportToCSV } from '../../utils/export';

interface ExportButtonProps {
  data: any[];
  filename: string;
  columns?: { key: string; label: string }[];
  disabled?: boolean;
}

export default function ExportButton({ data, filename, columns, disabled }: ExportButtonProps) {
  return (
    <button
      disabled={disabled || !data.length}
      onClick={() => exportToCSV(data, filename, columns)}
      className="btn-secondary btn-sm gap-1.5"
      title="Export to CSV"
    >
      <Download size={14} />
      Export CSV
    </button>
  );
}
